import ReactSelect from "react-select";
import ReactAsyncSelect from "react-select/async";
import { createSelect } from "./createSelect";
export var AsyncSelect = createSelect(ReactAsyncSelect);
export var Select = createSelect(ReactSelect);
